import * as React from 'react';
import { atom, useAtom } from 'jotai';
import type { GetUnConfigBootStrapStoreInfoReturn, LeftTopNoticeReturn } from '../types/api';
import { useEffect } from 'react';
import { noop } from 'lodash-es';
import { refreshScenario, useRefreshListener } from 'views/Multitab/channel';
import useLLM from '../hooks/useLLM';
import { queries } from 'services/queries';
import { useQuery } from '@tanstack/react-query';

type InProcessStateProps = {
  unConfigBasicCount: number;
  unConfigAIModelCount: number;
  unConfigAdvancedCount: number;
};

const InProcessState = atom<InProcessStateProps | null>(null);

const calContent = (value: LeftTopNoticeReturn): InProcessStateProps => {
  const unConfigBasicCount = value?.configureBootstrap?.unConfigBasicCount || 0;
  const unConfigAIModelCount = value?.configureBootstrap.unConfigAIModelCount || 0;
  const unConfigAdvancedCount = value?.configureBootstrap?.unConfigAdvancedCount || 0;
  return {
    unConfigBasicCount,
    unConfigAIModelCount,
    unConfigAdvancedCount,
  };
};

let refreshFn = noop;

export const useInProcessState = () => {
  const [state, setState] = useAtom(InProcessState);

  const LLM = useLLM();

  const { data, refetch } = useQuery({
    ...queries.notices.leftTopNotice(LLM),
    enabled: state === null,
  });

  useEffect(() => {
    if (data) {
      setState(calContent(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    refreshFn = refetch;
  }, [refetch]);

  useRefreshListener('bootguide', refetch);

  return React.useMemo(() => {
    return state
      ? {
          ...state,
          unConfigAIModelCount: state.unConfigAIModelCount,
          badgeCount:
            state.unConfigBasicCount + state.unConfigAIModelCount + state.unConfigAdvancedCount,
        }
      : {
          unConfigBasicCount: 0,
          unConfigAIModelCount: 0,
          unConfigAdvancedCount: 0,
          badgeCount: 0,
        };
  }, [state]);
};

export const refreshInProcessState = () => {
  refreshFn();
  refreshScenario('bootguide');
};

export const processingPendingRef: { current: null | Promise<any> } = {
  current: null,
};

export const activityUnConfigStores: { current: null | GetUnConfigBootStrapStoreInfoReturn } = {
  current: null,
};
